import { httpClient, HttpError } from "@coworker/http-client";
import { deepCopyAndConvertToSnakeCase } from "@coworker/reusable/helpers/objectAccess";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getStoreUsers(storeId: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `users/store/${encodeURIComponent(storeId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getActiveStoreUsers(storeId: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `users/active/store/${encodeURIComponent(storeId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getStoreSuperUsers(storeId: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `users/super-users/store/${encodeURIComponent(storeId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstSuperUsers(storeId: string): Promise<any> {
  return await httpClient.core.get<any>(
    `atkomst/super-users/${encodeURIComponent(storeId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getStoreTeams(storeId: string | null): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `teams/store/${encodeURIComponent(storeId!)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getTeam(teamId: string): Promise<any> {
  return await httpClient.core.get<any>(`teams/${encodeURIComponent(teamId)}`);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstTeams(storeId: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `atkomst/teams/${encodeURIComponent(storeId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getStoresByCountryId(countryId: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `stores/country/${encodeURIComponent(countryId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getCountries(): Promise<any[]> {
  return await httpClient.core.get<any[]>("countries/");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getFocusTile(userLanguage: string): Promise<any> {
  return await httpClient.core.get<any>(
    `upptacka-internal/focus-tiles/${userLanguage}`
  );
}

export async function getUserIdsForTeamId(teamId: string) {
  return await httpClient.core.get<{ data: { uid: string }[] }>(
    `users/v2/teamid/${encodeURIComponent(teamId)}`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getStoreContacts(storeId: string): Promise<any> {
  const result = await httpClient.core.get<any>(
    `stores/store-contacts/store/${encodeURIComponent(storeId)}`
  );
  return deepCopyAndConvertToSnakeCase(result);
}

export async function getUserPermissions(uid: string) {
  return await httpClient.core.get<string[]>(`users/${uid}/permissions`);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getUserByUid(uid: string): Promise<any> {
  return httpClient.core.get<any>(`users/byUid/${encodeURIComponent(uid)}`);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstStores(): Promise<any[]> {
  return await httpClient.core.get<any[]>("atkomst/stores");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstTeamsEditorStores(): Promise<any[]> {
  return await httpClient.core.get<any[]>("atkomst/teams-editor-stores");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstNodeUsers(nodeRef: string): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `atkomst/nodes/${encodeURIComponent(nodeRef)}/users`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstStoresByCountry(
  countryId: string
): Promise<any[]> {
  return await httpClient.core.get<any[]>(
    `atkomst/countries/${encodeURIComponent(countryId)}/stores`
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAtkomstCountries(): Promise<any[]> {
  return await httpClient.core.get<any[]>("atkomst/countries");
}

export async function getGraphDisplayName(
  emailOrId: string
): Promise<{ displayName: string | null }> {
  return await httpClient.core.post<{ displayName: string | null }>(
    "users/graph/display-name",
    { body: { emailOrId } }
  );
}

export async function getGraphDisplayNames(
  emails: string[]
): Promise<Record<string, string>> {
  return await httpClient.core.post<Record<string, string>>(
    "users/graph/display-names",
    { body: { emails } }
  );
}

export async function getGraphAvatar(emailOrId: string): Promise<Blob | null> {
  try {
    return await httpClient.core.post<Blob>("users/graph/avatar", {
      body: { emailOrId },
      responseType: "blob",
    });
  } catch (error) {
    // A 404 means the user has no photo — treat as non-error.
    // Rethrow anything else (401, 500, network failures) so Sentry can catch it.
    if (error instanceof HttpError && error.status === 404) {
      return null;
    }
    throw error;
  }
}
